module.exports = __webpack_public_path__ + "img/emotion-customization.85891e5.webp";